/* Language logic disabled */
const useLanguage = (_listingName: string, _singleName?: string): any => {
  return {};
};
export default useLanguage;
